// extracted by mini-css-extract-plugin
export default {"root":"fau3Vu","root-hide-wix-header":"vCafx8","rootHideWixHeader":"vCafx8"};